<div class="max-w-screen-2xl px-32 py-14 mx-auto">
  <div class="flex justify-between items-center mb-12">
    <span class="mat-display-2 font-bold mb-0">Feketelista</span>
    <button
      mat-flat-button
      color="primary"
      (click)="openCreateItemDialog()"
      class="mol-btn-md"
    >
      <mat-icon aria-label="Add icon">add</mat-icon>
      Felhasználó hozzáadása
    </button>
  </div>

  <form
    [formGroup]="queryFormGroup"
    (ngSubmit)="onSubmitQuery()"
    class="flex justify-between items-center gap-x-6 mb-8"
  >
    <mat-form-field appearance="standard" class="grow">
      <mat-label>Email</mat-label>
      <input
        matInput
        formControlName="email"
        type="email"
        (input)="clearQueryIncorrect()"
        autocomplete="email"
      />
      <mat-error *ngIf="queryFormGroup.get('email')?.hasError('email')">
        Az email cím formátuma nem megfelelő
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="standard" class="grow">
      <mat-label>Telefonszám</mat-label>
      <input
        matInput
        formControlName="phoneNumber"
        type="tel"
        (input)="clearQueryIncorrect()"
        autocomplete="tel-national"
      />
      <mat-error *ngIf="queryFormGroup.get('phoneNumber')?.hasError('pattern')">
        A telefonszám formátuma nem megfelelő
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="standard" class="grow">
      <mat-label>Jogosítvány szám</mat-label>
      <input
        matInput
        formControlName="licenseNumber"
        type="text"
        (input)="clearQueryIncorrect()"
        autocomplete="on"
      />
    </mat-form-field>

    <mat-form-field appearance="standard" class="grow">
      <mat-label>Születési dátum</mat-label>
      <input
        matInput
        formControlName="birthDate"
        [max]="birthDateMax"
        [matDatepicker]="birthDatePicker"
        (input)="clearQueryIncorrect()"
        autocomplete="bday"
      />
      <mat-datepicker-toggle
        matSuffix
        [for]="birthDatePicker"
      ></mat-datepicker-toggle>
      <mat-datepicker
        #birthDatePicker
        (opened)="clearQueryIncorrect()"
      ></mat-datepicker>
      <mat-error
        *ngIf="queryFormGroup.get('birthDate')?.hasError('matDatepickerParse')"
      >
        A dátum formátuma nem megfelelő
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="standard" class="grow">
      <mat-label>Lakcímkártya szám</mat-label>
      <input
        matInput
        formControlName="addressCardNumber"
        type="text"
        (input)="clearQueryIncorrect()"
        autocomplete="address-card-number"
      />
      <mat-error
        *ngIf="queryFormGroup.get('addressCardNumber')?.hasError('addressCard')"
      >
        A lakcímkártya szám 6 számból és 2 betűből kell álljon
      </mat-error>
    </mat-form-field>

    <button
      mat-button
      type="submit"
      aria-label="Search button"
      class="min-w-0 w-12 h-12 p-0 bg-white rounded-xl"
    >
      <mat-icon color="primary">search</mat-icon>
    </button>
  </form>

  <mat-card class="mat-elevation-z0 rounded-2xl p-14">
    <table
      mat-table
      [dataSource]="dataSource"
      fixedLayout="true"
      class="mat-elevation-z0 w-full"
    >
      <ng-container matColumnDef="reason">
        <th mat-header-cell *matHeaderCellDef>Indoklás</th>
        <td mat-cell *matCellDef="let element">{{ element.reason }}</td>
      </ng-container>

      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef class="w-40">
          Feketelistára<br />kerülés dátuma
        </th>
        <td mat-cell *matCellDef="let element" class="w-40">
          {{ formatDate(element.createdAt) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="createdByName">
        <th mat-header-cell *matHeaderCellDef class="w-56">Létrehozta</th>
        <td mat-cell *matCellDef="let element" class="w-56">
          {{ element.createdByName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="options">
        <th mat-header-cell *matHeaderCellDef class="w-24"></th>
        <td mat-cell *matCellDef="let element" class="w-24">
          <button
            mat-button
            color="primary"
            (click)="openDeleteItemDialogFor(element)"
            class="rounded-xl py-1 px-4 text-base font-bold"
          >
            <mat-icon color="primary" aria-label="Delete icon"
              >delete_outline</mat-icon
            >
            Törlés
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        [hidden]="this.loading"
      ></tr>
    </table>

    <div
      *ngIf="!dataAvailable()"
      class="flex flex-col justify-center items-center h-96"
    >
      <mat-spinner *ngIf="this.loading; else tableEmpty"></mat-spinner>

      <ng-template #tableEmpty>
        <ng-container *ngIf="!this.searchWasPerformed; else wasSearched">
          <img
            alt="Start searching icon"
            src="../../../assets/figures/boy-positive.svg"
            class="h-[88px] mb-2"
          />
          <p class="text-lg font-bold">Kezdj el keresni</p>
          <p class="text-sm">Tölts ki legalább egy mezőt a kereséshez</p>
        </ng-container>

        <ng-template #wasSearched>
          <img
            alt="No results"
            src="../../../assets/figures/man-questioning.svg"
            class="h-[88px] mb-2"
          />
          <p class="text-lg font-bold">Nincs találat</p>
          <p class="text-sm">Esetleg próbáld meg más adatokkal a keresést.</p>
        </ng-template>
      </ng-template>
    </div>
  </mat-card>
</div>
